import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const faqs = [
    {
        question: "What services does Lavanya Infotech provide?",
        answer:
            "Lavanya Infotech provides a range of services, including software development, mobile app development, web design and development, E-Commerce setup, SEO and digital marketing.",
    },
    {
        question: "What is Lavanya Infotech's pricing model?",
        answer:
            "We offer flexible pricing models—fixed cost, hourly billing, or milestone-based—depending on project size and duration.",
    },
    {
        question:
            "Which categories does Lavanya Infotech especially concentrate on assisting?",
        answer:
            "We specialize in startups, small businesses, and enterprises across domains such as healthcare, fintech, e-commerce, and real estate.",
    },
    {
        question:
            "How long does it typically take to complete a project with Lavanya Infotech?",
        answer:
            "Project timelines range from 2 weeks to 3 months depending on scope and complexity.",
    },
    {
        question: "What is the process for engaging Lavanya Infotech's services?",
        answer:
            "Our engagement process includes requirement gathering, proposal submission, design & development, testing, and deployment.",
    },
    {
        question: "Does Lavanya Infotech offer any training or onboarding services?",
        answer:
            "Yes, we provide onboarding sessions, user documentation, and walkthroughs for clients after deployment.",
    },
    {
        question: "Does Lavanya Infotech provide ongoing support for its solutions?",
        answer:
            "Yes, we offer support packages for bug fixes, enhancements, security patches, and performance tuning.",
    },
    {
        question:
            "How does Lavanya Infotech stay up-to-date with the latest technologies and trends?",
        answer:
            "We invest in research and development, attend tech events, and ensure our team is certified in modern tools.",
    },
    {
        question: "How does Lavanya Infotech ensure the security of its clients' data?",
        answer:
            "We use encryption, secure APIs, role-based access, and conduct regular audits to maintain data confidentiality.",
    },
    {
        question:
            "Can Lavanya Infotech provide references or case studies from previous clients?",
        answer:
            "Yes, we have several case studies and happy clients who can vouch for our work upon request.",
    },
];

const FaqAccordion = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleIndex = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="bg-black text-white py-12 px-4 sm:px-6 md:px-10">
            <div className="max-w-6xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className={`rounded-2xl transition-all duration-300 overflow-hidden shadow-md border cursor-pointer ${activeIndex === index
                                ? "bg-[#0d0d0d] border-cyan-500"
                                : "bg-gray-100 text-black border-transparent"
                                }`}
                            onClick={() => toggleIndex(index)}
                        >
                            <div className="p-5 flex justify-between items-center">
                                <h4
                                    className={`text-base sm:text-lg md:text-base font-semibold leading-snug ${activeIndex === index ? "text-cyan-400" : ""
                                        }`}
                                >
                                    {faq.question}
                                </h4>
                                <span className="text-xl font-bold">
                                    {activeIndex === index ? "–" : "+"}
                                </span>
                            </div>

                            <AnimatePresence>
                                {activeIndex === index && (
                                    <motion.div
                                        key="content"
                                        initial={{ opacity: 0, height: 0 }}
                                        animate={{ opacity: 1, height: "auto" }}
                                        exit={{ opacity: 0, height: 0 }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        <div className="px-5 pb-5 text-sm sm:text-base text-gray-300 leading-relaxed">
                                            {faq.answer}
                                        </div>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FaqAccordion;
